module.exports = __webpack_public_path__ + "static/img/img_campaign3.9ee10fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_campaign3.png
// module id = c41/
// module chunks = 0